import type { QuizKitCopy } from '@peach/types/quizzes/generated-quiz.dto.js';
import { withIds } from '@peach/types/quizzes/create-body.js';
import type { UpdateQuizBody } from '@peach/types/quizzes/quiz.dto.js';
import type { EditableQuiz } from '@/components/builder/QuizFields';

/**
 * The edit screen's draft as `PATCH /quizzes/:id` takes it; ids are re-minted, so an
 * edit is a whole new list. `kit` travels only for a quiz that already had one.
 */
export function toUpdateBody(quiz: EditableQuiz, kit?: QuizKitCopy): UpdateQuizBody {
  return { title: quiz.title, questions: withIds(quiz.questions), ...(kit && { kit }) };
}
